import * as React from 'react';
import * as wijmo from '@grapecity/wijmo';
import { CollectionView } from '@grapecity/wijmo';

import * as wjChart from '@grapecity/wijmo.react.chart';
import * as wjGrid from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';

import { Col, Row, Container } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';
import { toInt, toFloat, calcRate } from 'utils/numberUtils';
import './Analysis.css';
import { calcMajorUnit, calcMaxValue } from 'views/Analysis/analysisUtils';

// 工事／管・小の比較グラフ
function AnalysisGlaphBigSmall(props) {
  // 分析データリスト
  const analysisList = props.analysisList;
  // 集計項目
  const summaryItems = props.summaryItems;
  // 分析種別
  const analysisKind = props.analysisKind;
  // 比較種別
  const comparisonKind = props.comparisonKind;
  // カテゴリ名
  const categoryName = props.categoryName;

  // プレフィックス
  const prefix = analysisKind.prefix;

  // 比較用のキー名
  const key1 = comparisonKind.key1;
  const key2 = comparisonKind.key2;

  // 契約率
  const [keiRate, setKeiRate] = useState([]);

  // 工事の件数
  const [bigCounts, setBigCounts] = useState([]);
  // 管・小の件数
  const [smallCounts, setSmallCounts] = useState([]);
  // 集計項目毎の円グラフデータ
  const [pieData, setPieData] = useState([]);

  useEffect(() => {
    // 工事の集計項目毎のデータを生成
    setBigCounts(
      summaryItems
        .filter((x) => !x.ignoreCalcTotal)
        .map((x) => {
          const count = analysisList.sourceCollection.reduce(
            (sum, item) => sum + toInt(item[`${prefix}${key1}_${x.key}`]),
            0
          );
          return {
            category: x.value,
            value: count,
          };
        })
    );
    // 工事の集計項目毎のデータを生成
    setSmallCounts(
      summaryItems
        .filter((x) => !x.ignoreCalcTotal)
        .map((x) => {
          const count = analysisList.sourceCollection.reduce(
            (sum, item) => sum + toInt(item[`${prefix}${key2}_${x.key}`]),
            0
          );
          return {
            category: x.value,
            value: count,
          };
        })
    );

    // 円グラフデータを生成
    setPieData(
      summaryItems.map((item) => {
        const key1Value = analysisList.sourceCollection.reduce(
          (sum, data) => sum + (data[`${prefix}${key1}_${item.key}`] || 0),
          0
        );
        const key2Value = analysisList.sourceCollection.reduce(
          (sum, data) => sum + (data[`${prefix}${key2}_${item.key}`] || 0),
          0
        );
        return {
          category: item.label,
          data: [
            { name: comparisonKind.key1Value, value: key1Value },
            { name: comparisonKind.key2Value, value: key2Value },
          ],
        };
      })
    );
  }, [analysisList, analysisKind, summaryItems, comparisonKind]);

  // 積み上げ棒グラフ用のmax値（big+smallの合計値の最大）
  const stackedMax = Math.max(
    ...summaryItems
      .filter((x) => !x.ignoreCalcTotal)
      .map((_, i) => (bigCounts[i]?.value ?? 0) + (smallCounts[i]?.value ?? 0))
  );

  return (
    <>
      <Row className="mt-2">
        <Col md={summaryItems.length <= 10 ? '6' : '12'}>
          <wjChart.FlexChart
            header={`${comparisonKind.value}　${categoryName}（${analysisKind.value}）【内訳】`}
            chartType="Column"
            stacking="Stacked"
            bindingX="category"
            itemsSource={summaryItems
              .filter((x) => !x.ignoreCalcTotal)
              .map((item, i) => ({
                category: item.label,
                big: bigCounts[i]?.value ?? 0,
                small: smallCounts[i]?.value ?? 0,
              }))}
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
            options={{
              groupWidth: '34px', // 棒グラフの幅
            }}
          >
            {/* Y軸の設定 */}
            <wjChart.FlexChartAxis
              wjProperty="axisY"
              format="n0"
              max={stackedMax}
              majorUnit={calcMajorUnit([...bigCounts, ...smallCounts])}
            />
            <wjChart.FlexChartSeries name={comparisonKind.key1Value} binding="big" />
            <wjChart.FlexChartSeries name={comparisonKind.key2Value} binding="small" />
          </wjChart.FlexChart>
        </Col>
      </Row>
      <Row>
        {pieData.map((item, index) => (
          <Col md={summaryItems.length <= 10 ? '3' : '2'} key={index}>
            <wjChart.FlexPie
              header={`${item.category}`}
              bindingName="name"
              binding="value"
              itemsSource={item.data}
              style={{ backgroundColor: '#f7f7f8', borderRadius: '8px', height: '200px' }}
              startAngle={90}
            />
          </Col>
        ))}
      </Row>
    </>
  );
}
export default AnalysisGlaphBigSmall;
